import { render, staticRenderFns } from "./serviceScriptMng.vue?vue&type=template&id=6d637f43"
import script from "./serviceScriptMng.vue?vue&type=script&lang=js"
export * from "./serviceScriptMng.vue?vue&type=script&lang=js"
import style0 from "./serviceScriptMng.vue?vue&type=style&index=0&id=6d637f43&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports